<ng-template #quantity>
    <shared-quantity class="wizzard-quantity" [size]="size" [mode]="mode" (onIncrement)="handleIncrement($event)"
        (onDecrement)="handleDecrement($event)" [disabled]="disabled" (onRemove)="handleRemove($event)"
        [quantity]="quantity$ | async" [max]="max" [minimumHide]="minimumHide" [remove]="remove">
    </shared-quantity>
</ng-template>

<projection-for-device *ngIf="mobile || desktop" [mobile]="mobile ? quantity : null"
    [desktop]="desktop ? quantity : null"></projection-for-device>
